import Provider from "./src/components/context/provider"

//Wrap root element with Provider for shared state
export const wrapRootElement = Provider
